import { render, staticRenderFns } from "./ForgotPasswordDialog.vue?vue&type=template&id=61708456"
import script from "./ForgotPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordDialog.vue?vue&type=style&index=0&id=61708456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports